var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifislash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.06 2.241 35.435 29.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-wifi-slash-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.141 31.484C30.43 32.754 32.519 32.754 33.789 31.445C35.019 30.176 35.019 28.145 33.769 26.875L8.164 1.27C6.895 0 4.805 0 3.535 1.27C2.285 2.539 2.285 4.648 3.555 5.879Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-wifi-slash-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.461 16.875C2.754 17.187 3.223 17.187 3.535 16.855C7.305 12.852 12.246 10.762 17.773 10.762C23.34 10.762 28.301 12.871 32.07 16.875C32.344 17.168 32.793 17.148 33.105 16.836L35.293 14.668C35.566 14.375 35.547 14.023 35.332 13.75C31.738 9.297 24.961 5.977 17.773 5.977C10.605 5.977 3.828 9.297 0.215 13.75C0 14.023 0 14.375 0.273 14.668Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.809 23.262C9.141 23.613 9.59 23.555 9.922 23.203C11.719 21.172 14.687 19.687 17.773 19.707C20.898 19.687 23.848 21.23 25.703 23.262C25.996 23.594 26.406 23.574 26.758 23.242L29.199 20.84C29.453 20.586 29.473 20.215 29.258 19.922C26.914 17.09 22.637 14.902 17.773 14.902C12.91 14.902 8.633 17.09 6.309 19.922C6.074 20.215 6.074 20.547 6.367 20.84Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.773 31.602C18.145 31.602 18.437 31.445 19.062 30.84L22.832 27.227C23.066 26.992 23.125 26.602 22.91 26.328C21.875 25 19.98 23.848 17.773 23.848C15.488 23.848 13.594 25.059 12.578 26.445C12.422 26.68 12.5 26.992 12.754 27.227L16.484 30.84C17.109 31.426 17.422 31.602 17.773 31.602Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.508 30.117C31.035 30.645 31.894 30.645 32.402 30.117C32.91 29.59 32.93 28.75 32.402 28.223L6.816 2.637C6.289 2.109 5.43 2.109 4.902 2.637C4.395 3.145 4.395 4.043 4.902 4.531Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifislash);
export default __webpack_public_path__ + "static/media/wifi.slash.40c384f6f357df03ab33750546cb8a0f.svg";
export { ForwardRef as ReactComponent };